const publicArea = "";
export const privateArea = "/private";

/// //////// Public pages ///////////
export const trainingCourses = `https://www.brcgs.com/directory/brcgs-training-courses/`;
export const about = `https://www.brcgs.com/digital-solutions/directory-pro/`;
export const accessLogos = `https://www.brcgs.com/directory/access-and-logos/`;
export const contact = `https://www.brcgs.com/directory/contact-information/`;
export const auditSiteSharing = `https://www.brcgs.com/directory/audit-and-site-sharing/`;
export const raiseQuery = `https://eu.jotform.com/BRCGS_forms/directoryqueryform`;
export const raiseQueryCompanyUser = `https://form.jotform.com/BRCGS_forms/company-query-form`;
export const upgradeToProLink = `https://www.brcgs.com/product/directory-pro/p-32870/`
export const certificatedSite = `https://www.brcgs.com/directory/access`
// export const upgradeToMoreFavouritesLink = `https://www.brcgs.com/contact-us/register-your-interest/` // Keeping this so that when the devs of BRCGS.com finish their job we can swap it in.
export const upgradeToMoreFavouritesLink = `https://form.jotform.com/BRCGS_forms/company-query-form`
export const publicPage = `${publicArea}/`;
export const eula = `${publicArea}/eula`;
export const termsConditions = `${publicArea}/terms-conditions`;
export const privacyPolicy = `${publicArea}/privacy-policy`;
export const companyCreate=`${publicArea}/create`;
export const userCreate=`${publicArea}/user`;
export const publicDirectoryBannerLink = `https://solutions.brcgs.com/l/31922/2025-08-15/wpthrv`;
export const upgradeAPILink = `https://www.brcgs.com/product/directory-api/p-32872/`;
export const eulaLink = `https://www.brcgs.com/directory/terms-conditions-directory-pro/`
export const termsAndConditionsLink = `https://www.brcgs.com/directory/terms-conditions-directory-pro/`
export const privacyPolicyLink = `https://www.brcgs.com/directory/privacy-notice-directory-pro/`
export const formLink = `https://form.jotform.com/210703256820043`
/// //////// Private pages ///////////
export const PATH_REPORT_MANAGEMENT = `${privateArea}/report`;
export const PATH_NOTIFICATION_MANAGEMENT = `${privateArea}/notification`;
export const PATH_DASHBOARDS = `${privateArea}/dashboard`;
export const PATH_ADMINISTRATION = `${privateArea}/administration`;
export const PATH_IFS_REPORT_MANAGEMENT = `${privateArea}/IFSAudit`;

/// //////// API children ///////////
export const AccreditationBodies = "/AccreditationBodies";
export const Sites = "/Sites";
export const Modules = "/Modules";

export const all = "/all";

/// //////// Extensions ///////////
export const details = "/details";
export const edit = "/edit";
export const create = "/create";
export const office = "/office";
export const site = "/site";
export const idParam = "/:id";
export const archive = "/Archive";
export const unarchive = "/Unarchive";
export const certificationStatus = "/CertificationStatus";
export const schedules = "/schedules";
export const expiryReasons = "/ExpiryReasons";
export const scheduleTypes = "/ScheduleTypes";
export const API_REPORT = "/Report";
export const uploadDocument = "/UploadDocument";
export const getTrainingTypes = "/getTrainingTypes";
export const deleteAuditorCategory = "/deleteAuditorCategory";
export const suspendAuditorCategory = "/suspendAuditorCategory";
export const unsuspendAuditorCategory = "/unsuspendAuditorCategory";
export const synchroniseDetailsLocation = "/synchroniseDetailsLocation";
export const synchroniseDetailsSiteName = "/SynchroniseDetailsSiteName";
export const search = "/search";
export const getNotSharingReasons = "/getNotSharingReasons";
export const getCBoptions = "/getCertificationBodyOptions";
export const postToggleNotification = "/ToggleNotification";
export const changeLog = "/changeLog";
export const companyCreateOutside = "/CompanyCreateOutside"
export const createUser = "/createUser"

/// ////////////////
